import { useContext } from 'react';
import { TemplatesContext } from '../context/TemplatesContext';

export const useTemplatesData = () => useContext(TemplatesContext);
